import { useState } from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import Typography from '@mui/material/Typography'
import ErrorRoundedIcon from '@mui/icons-material/ErrorRounded'
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined'

import { useSendPaymentRequestEmail } from '@/hooks/api/use-yearly-fee-payment'

function SendDialog({
    yearlyFeePaymentId,
    handleClose,
}: {
    yearlyFeePaymentId: number,
    handleClose: () => void,
}) {

    const [requestInProgress, setRequestInProgress] = useState<boolean>(false)
    const [error, setError] = useState<string | null>(null)
    const [success, setSuccess] = useState<boolean>(false)

    const mutation = useSendPaymentRequestEmail(
        yearlyFeePaymentId,
        {
            setRequestInProgress,
            onErrorCallback(errorMessage) {
                setError(errorMessage)
            },
            onSuccessCallback() {
                setSuccess(true)
            },
        },
    )

    const handleClickDelete = () => {
        setRequestInProgress(true)
        mutation.mutate()
    }

    return (
        <Box sx={{
            minWidth: 200,
            minHeight: 100,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
        }}>
            {error &&
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: 2,
                    px: 3,
                }}>
                    <ErrorRoundedIcon sx={{
                        color: 'error.main',
                        fontSize: '4rem',
                    }}/>
                    <Typography variant="body1" component="div">
                        Email se nepodařilo odeslat:
                    </Typography>
                    <Typography variant="body2" component="div">
                        {error}
                    </Typography>
                    <Button
                        variant="contained"
                        color="terciary"
                        size="small"
                        onClick={() => {
                            setError(null)
                            handleClose()
                        }}
                    >
                        {'Zavřít'}
                    </Button>
                </Box>
            }
            {success &&
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: 2,
                    px: 3,
                }}>
                    <EmailOutlinedIcon sx={{
                        color: 'terciary.main',
                        fontSize: '4rem',
                    }}/>
                    <Typography variant="body1" component="div">
                        Email úspěšně odeslán.
                    </Typography>
                    <Button
                        variant="contained"
                        color="terciary"
                        size="small"
                        onClick={() => {
                            setSuccess(false)
                            handleClose()
                        }}
                    >
                        {'Zavřít'}
                    </Button>
                </Box>
            }
            {(!error && !success) &&
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}>
                    <Typography variant="h5" component="div" mb={2}>
                        Potvrďte prosím odeslání emailu s platbou ID: {yearlyFeePaymentId}
                    </Typography>
                    <Typography variant="body2" component="div" mb={2}>
                        Tato akce odešle email poplatníkovi.
                    </Typography>
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        flexGrow: 1,
                    }}>
                        <Button
                            variant="text"
                            color="terciary"
                            onClick={() => handleClose()}
                        >
                            Zrušit
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            startIcon={requestInProgress ? <CircularProgress color="inherit" size={20} /> : <EmailOutlinedIcon />}
                            onClick={() => handleClickDelete()}
                            disabled={requestInProgress}
                        >
                            Odeslat
                        </Button>
                    </Box>
                </Box>
            }
        </Box>
    )
}

export default SendDialog
